/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { EducationLevel, Gender, IdTypes } from '../types/utils';
import { UpdateExperienceInput } from './update-experience-input';
import { PaymentMethodID } from './payment-method-model';
import { CreateWalletInput } from './create-wallet-input';
import { UpdateCompanyInput } from './update-company-input';
import { UpdateFrequency } from '../types/utils';
import { User } from './user-model';

export class UpdateUserInput {
	address?: string

	addressCity?: string

	addressCountry?: string

	addressZipcode?: string

	birthCity?: string

	birthDate?: Date

	cellphone?: string

	citizenship?: string

	company?: UpdateCompanyInput

	defaultPaymentMethod?: PaymentMethodID

	employment?: string

	experience?: UpdateExperienceInput

	firstName?: string

	gender?: Gender

	highestEducation?: EducationLevel

	idDocumentCountry?: string

	idDocumentExpiryDate?: Date

	idDocumentIssueDate?: Date

	idDocumentIssuingAgency?: string

	idDocumentNumber?: string

	idDocumentType?: IdTypes

	lastName?: string

	notUSTax?: boolean

	politicallyExposed?: boolean

	politicallyExposedReason?: string

	subscribedToProductUpdates?: boolean

	taxNumber?: string

	wallet?: CreateWalletInput
}

export const UserUpdatability = {
	address: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	addressCity: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	addressCountry: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	addressZipcode: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	birthCity: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	birthDate: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	cellphone: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	citizenship: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	company: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted(), subtarget: UpdateCompanyInput},
	defaultPaymentMethod: { frequency: UpdateFrequency.Updatable },
	employment: { frequency: UpdateFrequency.Updatable },
	experience: { frequency: UpdateFrequency.Updatable },
	firstName: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	gender: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	highestEducation: { frequency: UpdateFrequency.Updatable },
	idDocumentCountry: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	idDocumentExpiryDate: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	idDocumentIssueDate: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	idDocumentIssuingAgency: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	idDocumentNumber: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	idDocumentType: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	lastName: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	notUSTax: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	politicallyExposed: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	politicallyExposedReason: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	subscribedToProductUpdates: { frequency: UpdateFrequency.Updatable },
	taxNumber: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	wallet: { frequency: UpdateFrequency.NotUpdatable},
}